import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled", "type"]

import { computed, PropType, ButtonHTMLAttributes } from 'vue'
import '@/styles/ms-button-styles.scss'
import { ButtonSize, ButtonStyles } from '@/utilities/enums'


export default /*@__PURE__*/_defineComponent({
  __name: 'MsButton',
  props: {
  disabled: {
    type: Boolean,
    default: false
  },
  buttonType: {
    type: String as PropType<ButtonStyles>,
    required: false
  },
  buttonCustomStyle: {
    type: String,
    required: false
  },
  buttonSize: {
    type: String as PropType<ButtonSize>,
    required: false
  },
  buttonFont: {
    type: String,
    default: 'NKT-P1-medium'
  },
  buttonAttribute: {
    type: String as PropType<ButtonHTMLAttributes['type']>,
    default: 'button'
  },
  width: {
    type: String,
    required: false,
    default: '$ms-button-standard-height'
  },
  height: {
    type: String,
    required: false,
    default: '$ms-button-standard-min-width'
  },
  padding: {
    type: String,
    required: false,
    default: '$ms-button-standard-padding'
  }
},
  emits: ['click'],
  setup(__props, { emit: __emit }) {

_useCssVars(_ctx => ({
  "222d18ad": (__props.height),
  "22f79d80": (__props.width),
  "78e6b56a": (__props.padding)
}))

const props = __props

const emit = __emit

const handleClick = () => {
  emit('click')
}

const buttonStyle = computed(() => {
  switch (props.buttonType) {
    case ButtonStyles.PrimaryBlue:
      return 'ms-button-primary-blue'
    case ButtonStyles.PrimaryOrange:
      return 'ms-button-primary-orange'
    case ButtonStyles.PrimaryGreen:
      return 'ms-button-primary-green'
    case ButtonStyles.Secondary:
      return 'ms-button-secondary'
    case ButtonStyles.Tertiary:
      return 'ms-button-tertiary'
    default:
      return 'ms-button-none'
  }
})

const buttonStyleSize = computed(() => {
  switch (props.buttonSize) {
    case ButtonSize.Standard:
      return 'ms-button-standard-size'
    case ButtonSize.Details:
      return 'ms-button-details-size'
    case ButtonSize.Small:
      return 'ms-button-small-size'
    case ButtonSize.Custom:
      return 'ms-button-custom-size'
    case ButtonSize.NoPadding:
      return 'ms-button-none-size'
    default:
      return ''
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["btn ms-button ms-button-style", [buttonStyle.value, buttonStyleSize.value, __props.buttonFont, __props.buttonCustomStyle]]),
    disabled: __props.disabled,
    type: __props.buttonAttribute,
    onClick: handleClick
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 10, _hoisted_1))
}
}

})